import Breadcrumb from "components/Common/Breadcrumb";
import DashboardLoader from "components/Loader/DashboardLoader";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { useCreateWorkLogMutation } from "store/features/client/clientManagementApi";
import { useGetAllProjectsQuery } from "store/features/client/clientManagementApi";
import { useSelector } from "react-redux";
import { selectUser } from "store/features/auth/authSlice";
import { toast } from "sonner";

const AddWorkLog = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  const [createWorkLog, { isLoading }] = useCreateWorkLogMutation();
  const { data: projects = [], isLoading: projectsLoading } = useGetAllProjectsQuery();

  const [formData, setFormData] = useState({
    project_id: "",
    title: "",
    work_summary: "",
    hours_spent: "",
    work_status: "In Progress",
    date: new Date().toISOString().split('T')[0]
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const workLogData = {
        ...formData,
        employer_id: user.id,
        employer_name: user.nickname || user.name,
        employer_role: user.role,
        hours_spent: parseFloat(formData.hours_spent) || 0
      };

      await createWorkLog(workLogData).unwrap();
      toast.success("Work log added successfully!");
      navigate("/worklog");
    } catch (error) {
      toast.error("Failed to add work log");
      console.error('Work log creation error:', error);
    }
  };

  if (projectsLoading) {
    return <DashboardLoader />;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb
          title="Add Work Log"
          breadcrumbItem={
            <>
              <Link to="/worklog">Work Log</Link> / Add Work Log
            </>
          }
        />

        <Row className="justify-content-center">
          <Col lg={8}>
            <Card>
              <CardBody>
                <h4 className="card-title mb-4">Add Today's Work Log</h4>

                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label">Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label">Project</label>
                        <select
                          className="form-select"
                          name="project_id"
                          value={formData.project_id}
                          onChange={handleChange}
                        >
                          <option value="">Select Project (Optional)</option>
                          {projects.map(project => (
                            <option key={project.id} value={project.id}>
                              {project.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="mb-3">
                        <label className="form-label">Title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Enter work title (optional)"
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label">Hours Spent</label>
                        <input
                          type="number"
                          step="0.01"
                          min="0.01"
                          max="24"
                          className="form-control"
                          name="hours_spent"
                          value={formData.hours_spent}
                          onChange={handleChange}
                          required
                        />
                        <small className="text-muted">Enter hours spent (0.5 for 30 minutes)</small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label">Work Status</label>
                        <select
                          className="form-select"
                          name="work_status"
                          value={formData.work_status}
                          onChange={handleChange}
                          required
                        >
                          <option value="In Progress">In Progress</option>
                          <option value="Completed">Completed</option>
                          <option value="Pending">Pending</option>
                          <option value="Blocked">Blocked</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="mb-3">
                        <label className="form-label">Work Summary</label>
                        <textarea
                          className="form-control"
                          name="work_summary"
                          value={formData.work_summary}
                          onChange={handleChange}
                          rows="6"
                          placeholder="Describe what you worked on today..."
                          required
                        />
                        <small className="text-muted">
                          Be specific about tasks completed, progress made, and any challenges faced.
                        </small>
                      </div>
                    </Col>
                  </Row>

                  <div className="mt-4">
                    <Button
                      type="submit"
                      color="primary"
                      className="me-2"
                      disabled={isLoading}
                    >
                      {isLoading ? "Adding..." : "Add Work Log"}
                    </Button>
                    <Button
                      type="button"
                      color="light"
                      onClick={() => navigate("/worklog")}
                    >
                      Cancel
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddWorkLog;